module.exports = __webpack_public_path__ + "img/image.cee34732.svg";